module.exports = __webpack_public_path__ + "img/Photo39.f610d469.jpg";